var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDotsPattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 342,
    height: 342,
    viewBox: "0 0 342 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6042_28521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.00001 3L3 338.6",
    stroke: "#CBD5E1",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.25 3V338.6",
    stroke: "#CBD5E1",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5 3V338.6",
    stroke: "#CBD5E1",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.75 3V338.6",
    stroke: "#CBD5E1",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 3V338.6",
    stroke: "#CBD5E1",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.25 3V338.6",
    stroke: "#CBD5E1",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5 3V338.6",
    stroke: "#CBD5E1",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.75 3V338.6",
    stroke: "#CBD5E1",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125 3V338.6",
    stroke: "#CBD5E1",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.25 3V338.6",
    stroke: "#CBD5E1",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.5 3V338.6",
    stroke: "#CBD5E1",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.75 3V338.6",
    stroke: "#CBD5E1",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186 3V338.6",
    stroke: "#CBD5E1",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.25 3V338.6",
    stroke: "#CBD5E1",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.25 3V338.6",
    stroke: "#CBD5E1",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.5 3V338.6",
    stroke: "#CBD5E1",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.5 3V338.6",
    stroke: "#CBD5E1",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.75 3V338.6",
    stroke: "#CBD5E1",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.75 3V338.6",
    stroke: "#CBD5E1",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308 3V338.6",
    stroke: "#CBD5E1",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247 3V338.6",
    stroke: "#CBD5E1",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.25 3V338.6",
    stroke: "#CBD5E1",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.5 3V338.6",
    stroke: "#CBD5E1",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6042_28521"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 342,
    height: 342,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsPattern);
export default __webpack_public_path__ + "static/media/dots-pattern.7533f73261d0e1519e6b372b19439d5c.svg";
export { ForwardRef as ReactComponent };